<template>
  <div class="dashboard-container" v-loading="fetchLoding">
    <div>
      <!-- <img src="/static/img/home.png" style="width: 16px; vertical-align: middle;"> -->
      <el-tag style="font-size: 12px;">店铺地址:
        <a
          :href="shopForm.shop_mobile_url"
          target="_blank"
          style="text-decoration:underline;"
        >{{ shopForm.shop_mobile_url }}</a>
      </el-tag>
      <el-popover placement="bottom" width="220" trigger="click">
        <div style="text-align: center; margin: 0 auto;">
          <canvas id="qrcode" style="width: 100%;"/>
        </div>
        <img src="/img/qrcode.png" style="width: 22px; margin-left: 10px; vertical-align: middle;" slot="reference" @click="createQrcode()">
      </el-popover>
    </div>
    <el-form ref="shopForm" :model="shopForm" label-width="70px" style="margin-top: 20px;">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span><b>温馨提示</b></span>
        </div>
        <div>
          <p>收到客户订单消息，您需要完成以下两步骤：</p>
          <p>1、点击右上角头像图标，绑定客服微信；</p>
          <p>2、关注ieMall公众号，随时收到订单消息，同时还可以在公众号找到微小店管理软件。</p>
        </div>
        <div>
          <img src="/img/iemall.jpeg" style="width: 120px;">
        </div>
      </el-card>
      <el-card class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span><b>店铺基本信息</b></span>
        </div>
        <el-form-item :label="generateCustomizeString('shopName')">
          <el-input v-model="shopForm.display_shop_name" style="max-width: 320px;"/>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('shopLogo')">
          <el-upload
            :data="qiniuData"
            :limit="2"
            :drag="true"
            :file-list="fileList"
            :on-change="handleChange"
            :on-success="handleAvatarSuccess"
            :on-error="handleError"
            :before-upload="beforeAvatarUpload"
            action="https://upload-z2.qiniup.com"
            v-loading="logoLoading"
            element-loading-text="图片上传中"
          >
            <img v-if="shopForm.shop_logo_url" :src="displayLogoUrl" class="avatar">
            <div v-else>
              <i class="el-icon-upload"/>
              <div class="el-upload__text">
                {{ generateCustomizeString('uploadFile') }}
                <em>{{ generateCustomizeString('clickUpload') }}</em>
              </div>
            </div>
            <div
              slot="tip"
              class="el-upload__tip"
              style="line-height: 20px;"
            >{{ generateCustomizeString('uploadAlert') }}，推荐logo尺寸比例1:1</div>
          </el-upload>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('shopAddress')">
          <el-input v-model="shopForm.merchant_address" style="max-width: 320px;"/>
        </el-form-item>
        <el-form-item :label="generateCustomizeString('shopDesc')">
          <el-input v-model="shopForm.business_profile" type="textarea" style="max-width: 320px;"/>
        </el-form-item>
      </el-card>
      <el-card class="box-card" style="margin-top: 20px;">
        <div slot="header" class="clearfix">
          <span><b>店铺联系信息</b></span>
        </div>
        <el-form-item label="客服微信二维码">
          <el-upload
            :data="qiniuData"
            :limit="2"
            :drag="true"
            :file-list="qrFileList"
            :on-change="handleQrChange"
            :on-success="handleQrSuccess"
            :on-error="handleError"
            :before-upload="beforeQrUpload"
            action="https://upload-z2.qiniup.com"
            v-loading="qrLoading"
            element-loading-text="图片上传中"
          >
            <img v-if="shopForm.configs.shop_qr" :src="displayWechatQr" class="avatar">
            <div v-else>
              <i class="el-icon-upload"/>
              <div class="el-upload__text">
                {{ generateCustomizeString('uploadFile') }}
                <em>{{ generateCustomizeString('clickUpload') }}</em>
              </div>
            </div>
            <div
              slot="tip"
              class="el-upload__tip"
              style="line-height: 20px;"
            >{{ generateCustomizeString('uploadAlert') }}</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="客服微信" prop="wechat_id">
          <el-input v-model="shopForm.wechat_id" style="max-width: 320px;"></el-input>
        </el-form-item>
        <el-form-item label="联系文案" prop="wechat_message">
          <el-input type="textarea" autosize v-model="shopForm.wechat_message" style="max-width: 320px;"></el-input>
        </el-form-item>
      </el-card>
      <!-- <div style="margin-top: 30px; margin-bottom: 10px; color: #606266;">
        <span>店铺绑定微信公众号后使用</span>
        <hr style="border:1px dashed;">
      </div> -->
      <el-card class="box-card" style="margin-top: 20px;" v-if="shopForm.wx_appid">
        <div slot="header" class="clearfix">
          <span><b>店铺公众号信息</b></span>
          <span style="font-size: 12px; color: #555;">— 店铺绑定微信公众号后使用</span>
        </div>
        <el-form-item label="微信公众号首次关注欢迎图片">
          <el-upload
            :data="qiniuData"
            :limit="2"
            :drag="true"
            :file-list="welcomeFileList"
            :on-change="handleWelcomeChange"
            :on-success="handleWelcomeImageSuccess"
            :on-error="handleError"
            :before-upload="beforeWelcomeUpload"
            action="https://upload-z2.qiniup.com"
            v-loading="welcomeLoading"
            element-loading-text="图片上传中"
          >
            <img v-if="shopForm.configs.oa_welcome_image" :src="displayWelcomeImgUrl" class="avatar">
            <div v-else>
              <i class="el-icon-upload"/>
              <div class="el-upload__text">
                {{ generateCustomizeString('uploadFile') }}
                <em>{{ generateCustomizeString('clickUpload') }}</em>
              </div>
            </div>
            <div
              slot="tip"
              class="el-upload__tip"
              style="line-height: 20px;"
            >{{ generateCustomizeString('uploadAlert') }}</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="微信 APP ID" prop="wx_appid">
          <el-input v-model="shopForm.wx_appid" disabled style="max-width: 320px;"></el-input>
        </el-form-item>
        <el-form-item label="微信公众号对接回调Token" prop="oa_token">
          <el-input v-model="shopForm.oa_token" disabled style="max-width: 320px;"></el-input>
        </el-form-item>
      </el-card>
      <div style="margin-top: 20px; margin-left: 30px;">
        <el-button type="primary" @click="updateShop()" style="width: 100px;">{{ generateCustomizeString('update') }}</el-button>
      </div>
    </el-form>

    <!-- 弹出协议同意框 -->
    <!-- <el-dialog
      title="温馨提示"
      :visible.sync="policyYetAgreed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      center
    >
      <el-dialog width="30%" title="三方协议书" :visible.sync="innerVisible" append-to-body></el-dialog>
      <span>
        阅读并同意
        <a
          @click="innerVisible = true"
          style="color: red; text-decoration: underline;"
        >&lt;三方协议书&gt;</a>
      </span>
      <div slot="footer" class="dialog-footer">
        <el-button @click="logout">拒绝并离开</el-button>
        <el-button type="primary" @click="agreePolicy()" class="btn-agree">同意</el-button>
      </div>
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import QrCodeWithLogo from 'qr-code-with-logo'

const defaultShop = {
  display_shop_name: '',
  shop_mobile_url: '',
  shop_logo_url: '',
  shop_logo_qiniu_res_key: '',
  merchant_address: '',
  business_profile: '',
  agent_level: '',
  wechat_id: '',
  wechat_message: '',
  wx_appid: '',
  oa_token: '',
  employee: {
    email: '',
    password: ''
  },
  configs: {
    shop_qr: '',
    shop_qr_res_key: '',
    oa_welcome_image_res_key: '',
    oa_welcome_image: ''
  }
}

export default {
  name: 'Home',
  data() {
    return {
      fetchLoding: false,
      shopForm: Object.assign({}, defaultShop),
      form: {
        name: '',
        address: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      shop_logo_qiniu_res_key: '',
      shop_logo_url: '',
      wechat_qr: '',
      wechat_qr_res_key: '',
      oa_welcome_image_res_key: '',
      oa_welcome_image: '',
      qiniuData: {
        token: ''
      },
      // policyYetAgreed: false,
      innerVisible: false,
      fileList: [],
      qrFileList: [],
      welcomeFileList: [],
      logoLoading: false,
      qrLoading: false,
      welcomeLoading: false,
      qrcode: ''
    }
  },
  computed: {
    ...mapGetters(['name', 'roles']),
    displayLogoUrl() {
      return (
        this.shopForm.shop_logo_url + '?imageView2/0/w/245/h/160/q/75|imageslim'
      )
    },
    displayWechatQr() {
      return (
        this.shopForm.configs.shop_qr +
        '?imageView2/0/w/245/h/160/q/75|imageslim'
      )
    },
    displayWelcomeImgUrl() {
      return (
        this.shopForm.configs.oa_welcome_image +
        '?imageView2/0/w/245/h/160/q/75|imageslim'
      )
    }
  },
  // mounted() {
  //   this.$nextTick(function() {
  //     // DOM操作
  //     canvas = document.getElementById('qrcode')
  //   })
  // },
  created() {
    this.fetchUploadToken()
    this.fetchShop()
  },
  methods: {
    generateCustomizeString,
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload() // 为了重新实例化vue-router对象 避免bug
      })
    },
    // agreePolicy() {
    //   request({
    //     url: 'policy/agree',
    //     method: 'post',
    //     params: {
    //       policy_agreed: 1
    //     }
    //   }).then(res => {
    //     if (res.status === 0) {
    //       this.$message({
    //         message: '已同意三方协议书!',
    //         type: 'success',
    //         center: true
    //       })
    //       this.policyYetAgreed = false
    //     }
    //   })
    // },
    handleAvatarSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.shopForm.shop_logo_qiniu_res_key = res.key
      this.shopForm.shop_logo_url = 'https://img.nzmai.com.cn/' + res.key
      this.logoLoading = false
      console.log(res)
    },
    handleError(res) {
      this.logoLoading = false
      this.qrLoading = false
      this.welcomeLoading = false
      // 显示错误
      console.log(res)
    },
    handleChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    handleQrSuccess(res, file) {
      // 上传成功后在图片框显示图片
      // 更改了key
      this.shopForm.configs.shop_qr_res_key = res.key
      this.shopForm.configs.shop_qr = 'https://img.nzmai.com.cn/' + res.key
      this.qrLoading = false
      console.log(res)
    },
    handleQrChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    handleWelcomeImageSuccess(res, file) {
      this.shopForm.configs.oa_welcome_image_res_key = res.key
      this.shopForm.configs.oa_welcome_image = 'https://img.nzmai.com.cn/' + res.key
      this.welcomeLoading = false
      console.log(res)
    },
    handleWelcomeChange(file, fileList) {
      if (fileList.length > 1) {
        fileList.splice(0, 1)
      }
    },
    beforeAvatarUpload(file) {
      // 在图片提交前进行验证
      this.logoLoading = true
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 4

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 4MB!')
      }

      return (isJPG || isPNG) && isLt2M
    },
    beforeQrUpload(file) {
      // 在图片提交前进行验证
      this.qrLoading = true
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 4

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 4MB!')
      }

      return (isJPG || isPNG) && isLt2M
    },
    beforeWelcomeUpload(file) {
      // 在图片提交前进行验证
      this.welcomeLoading = true
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 4

      if (!isJPG && !isPNG) {
        this.$message.error('上传头像图片只能是 JPG/PNG 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 4MB!')
      }

      return (isJPG || isPNG) && isLt2M
    },
    fetchUploadToken() {
      request({
        url: '/upload-token',
        method: 'get'
      })
        .then(res => {
          this.qiniuData.token = res.data['token']
        })
        .catch(error => {
          console.log(error)
        })
    },
    createQrcode() {
      QrCodeWithLogo.toCanvas({
        canvas: document.getElementById('qrcode'),
        content: this.shopForm.shop_mobile_url,
        width: 200,
        logo: {
          src: this.shopForm.shop_logo_url + '?imageView2/0/w/50/h/50/q/70|imageslim',
          borderRadius: 5
        }
      })
    },
    fetchShop() {
      if (this.fetchLoding) return
      this.fetchLoding = true

      request({
        url: 'basic',
        method: 'get'
      })
        .then(res => {
          if (res.status === 0) {
            for (const i in this.shopForm) {
              if (i === 'employee') {
                var employee = res.data['employees'][0]
                this.shopForm.employee.email = employee.email
                this.shopForm.employee.password = '****************'
              } else {
                this.shopForm[i] = res.data[i]
              }
            }
            if (location.host.includes('ieshop.co.nz')) {
              this.shopForm.shop_mobile_url = 'https://m.ieshop.co.nz/m/' + res.data.shop_domain_prefix + '/home'
            } else {
              this.shopForm.shop_mobile_url = process.env.VUE_APP_MOBILE_URL + res.data.shop_domain_prefix + '/home'
            }
            this.fetchLoding = false
          }
        })
        .catch(error => {
          console.log(error)
          this.fetchLoding = false
        })
    },
    updateShop() {
      var data = {
        display_shop_name: this.shopForm.display_shop_name,
        shop_logo_qiniu_res_key: this.shopForm.shop_logo_qiniu_res_key,
        merchant_address: this.shopForm.merchant_address,
        business_profile: this.shopForm.business_profile,
        wechat_id: this.shopForm.wechat_id,
        wechat_message: this.shopForm.wechat_message,
        wx_appid: this.shopForm.wx_appid,
        oa_token: this.shopForm.oa_token
      }
      data['configs'] = {
        shop_qr: this.shopForm.configs.shop_qr,
        oa_welcome_image: this.shopForm.configs.oa_welcome_image
      }
      request({
        url: 'basic',
        method: 'patch',
        data
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: '更新店铺信息成功',
              type: 'success',
              center: true
            })
          } else {
            this.$message.error({
              message: '更新店铺信息失败',
              center: true
            })
          }
        })
        .catch(error => {
          console.log(error)
          this.$message.error({
            message: '更新店铺信息失败',
            center: true
          })
        })
    }
  }
}
</script>

<style type="text/css">
.el-upload-dragger {
  width: 245px !important;
  height: 160px;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.dashboard {
  &-container {
    margin: 10px;
  }
  &-text {
    font-size: 30px;
    line-height: 46px;
  }
}
.btn-agree {
  margin-top: 10px;
}
</style>
